// src/components/AuthLanding.js
import React, { useEffect, useState } from 'react';
import Login from './Login';
import Register from './Register';
import '../App.css';
import MobileFooter from './MobileFooter';
import logo from '../assets/rankr_logo.svg'; // <-- NEW

const AuthLanding = () => {
  const [tab, setTab] = useState('login');

  // allow deep-link like /auth?tab=register
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get('tab') === 'register') setTab('register');
  }, []);

  return (
    <>
      <div className="auth-landing" style={{ maxWidth: 860, margin: '3rem auto', padding: '1rem' }}>
        {/* Brand row: wordmark + logo, centered as a unit */}
        <h1
          className="auth-brand"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,          // space between "rankr" and the logo
            marginBottom: 12,
            lineHeight: 1
          }}
        >
          <span style={{ fontWeight: 900 }}>rankr</span>
          {/* logo slightly smaller than the text via em-relative height */}
          <img
            src={logo}
            alt=""
            aria-hidden="true"
            style={{ height: '0.9em', width: 'auto', display: 'block' }}
          />
        </h1>

        <div style={{ display:'flex', gap:8, justifyContent:'center', marginBottom:12 }}>
          <button className={`btn ${tab==='login'?'btn-primary':''}`} onClick={() => setTab('login')}>Login</button>
          <button className={`btn ${tab==='register'?'btn-primary':''}`} onClick={() => setTab('register')}>Register</button>
        </div>

        <div style={{
          background:'rgba(255,255,255,0.02)',
          border:'1px solid var(--border)',
          borderRadius:16,
          padding:16
        }}>
          {tab === 'login' ? <Login/> : <Register/>}
        </div>
      </div>

      {/* Mobile-only footer (visibility controlled by your CSS) */}
      <MobileFooter />
    </>
  );
};

export default AuthLanding;
